import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './Alert.css';

const Alert = ({ alerts }) => (
  <div className="alert-wrapper mt-5">
    {alerts.map((alert) => (
      <div key={alert.id} className={`notification is-${alert.alertType} mb-1`}>
        {alert.msg}
      </div>
    ))}
  </div>
);

Alert.propTypes = {
  alerts: PropTypes.array.isRequired
};

const mapStateToProps = (state) => ({
  alerts: state.alert
});

export default connect(mapStateToProps)(Alert);
